import { IGetState, TCardId, TChecklistId } from '../../../../../../../../types/types';
import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { getChecklistItemsSection } from '../../selectors/getChecklistItemsSection';
import { checklistItemsUpdate } from '../../../../../../../../rest/effects/card/checklist/checklistItemsUpdate';

const getChecklistItems = getChecklistItemsSection();

export const onAllItemsDone = (
    cardId: TCardId,
    checklistId: TChecklistId
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const updatedChecklistItems = getChecklistItems(getState(), cardId, checklistId)
            .sort((a, b) =>  a.orderNumber - b.orderNumber) // KNB-4755
            .map((item, index) => {
                return { id: item.id, checked: true, orderNumber: index };
            });
        return dispatch(checklistItemsUpdate(cardId, checklistId, updatedChecklistItems));
    };
    return action;
};
